module.exports = " <div class=\"container home\"> <div class=\"d_table h_100 h_100_important\"> <div class=d_table_cell> <img src=" + require("../assets/images/guco-home.png") + " alt=\"Logo Guco\" class=\"img-responsive m_0_auto\"> </div> </div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Home.vue
// module id = 171
// module chunks = 0